import ViewController from "core/views/view.controller";

export default class BookingProcessorSelectionCtrl extends ViewController {
    static $inject = ['$scope', 'Bookings'];

    constructor() {
        super(...arguments);
        this.processors = [];

        // Bindings
        this.selectedProcessor = null;
        this.onProcessorSelected = null;
    }

    $onInit(){
        this.loadProcessors();
    }

    $onChanges(changes){
        if (changes.selectedProcessor && this.selectedProcessor != null) {
            if (this.selectedProcessor instanceof Object) {
                this.selectedProcessor = this.selectedProcessor.name;
            }
        }
    }

    loadProcessors() {
        this.Bookings.allProcessors().then((processors) => {
            this.processors = processors;
        });
    }

    selectProcessor(processor) {
        if (this.onProcessorSelected instanceof Function) {
            this.onProcessorSelected({processor: processor});
        }
    };

}



// WEBPACK FOOTER //
// ./src/modules/main/components/booking-processor-selection/booking-processor-selection.controller.js